import FormatUtils from "../../utils/FormatUtils";
import React from "react";

export default function Price({
                                  value
                              }) {
    return (
        <div
            className="whitespace-nowrap rounded-3xl bg-[#00ae11] text-2xl font-bold py-2 px-5 ml-2">{FormatUtils.formatAmount(value, true)}</div>)
}